/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { nthChildIterator } from '@insticator/insticator-ui';
import { aniSpeed } from '../../../utils/styles/general';



/* ++++++++++ --------------- PAGE CONTENT : STYLES --------------- ++++++++++ */
export default {
	pagecontent: {
		'& .cardwrapper, .expandablesection': {
			opacity: '0',
		    animationName: 'fadeInUp',
		    animationDuration: aniSpeed,
		    animationFillMode: 'forwards',
		    extend: nthChildIterator(100, .1, .1)
		}
	}
}; 